import api from '@/services/api/api';

export const useAuthors = (
  params = {
    page,
    filters: {},
  },
) => {
  const authors = useInfiniteQuery(
    ['authors', params.filters],
    async ({ pageParam = 1 }) => {
      const { data } = await api.authors.getAuthors(
        {
          per_page: params.per_page,
          page: pageParam,
        },
        toValue(params.filters),
      );

      return data;
    },
    {
      staleTime: Infinity,
      select: ({ pages }) => pages.flatMap((data) => data?.data),
      getNextPageParam: (data) => {
        return data.meta.current_page < data.meta.last_page
          ? data.meta.current_page + 1
          : undefined;
      },
      refetchOnMount: true,
    },
  );

  const queryClient = useQueryClient();

  const resetPage = (filters) => {
    queryClient.setQueryData(['authors', filters], (prevData) => {
      if (!prevData) return;
      return {
        pages: [prevData.pages[0]],
        pageParams: [prevData.pageParams[0]],
      };
    });
  };

  onServerPrefetch(async () => {
    await authors.suspense();
  });

  return {
    authors,
    resetPage,
  };
};
